import { createSelector } from 'reselect';

const getState = (state) => state.directOrderRecurring.data.insurance;

const getInsuredQuantity = createSelector(
  getState,
  (insurance) => insurance.insured_for
);

export default {
  getInsuredQuantity,
};
